import axios, { AxiosRequestConfig, AxiosPromise } from "axios";
import trackAction from "../tracking/actionTracking";

type GeolocationListener = (
  onData: (geolocationEvent: GeolocationPosition) => void,
  onError: (error: GeolocationPositionError) => void,
  options?: PositionOptions,
) => () => void;

export interface IGcpAppIo {
  axios: (config: AxiosRequestConfig) => AxiosPromise<any>;
  changeLocationHash: (hashPart: string) => void;
  changeLocation: (location: string) => void;
  getLocation: () => string;
  listenHashChangeEvent: any; // TODO: find out how to declare generators
  trackAction: (msg: string, params?: any) => void;
  watchGeolocation: GeolocationListener;
  back: () => void;
  alert: (msg: string) => void;
}

async function* listenHashChangeEvent() {
  let resolve: (newRoute: string) => void;
  let promise = new Promise((r) => (resolve = r));

  window.addEventListener("hashchange", (ev: HashChangeEvent) => {
    resolve(ev.newURL);
    promise = new Promise((r) => (resolve = r));
  });

  yield Promise.resolve(window.location.hash);
  while (true) {
    yield promise;
  }
}

const io: IGcpAppIo = {
  axios,
  changeLocationHash: (hashPart: string) => {
    window.location.hash = hashPart;
  },
  changeLocation: (location: string) => {
    window.location.replace(location);
  },
  getLocation: () => window.location.href,
  listenHashChangeEvent,
  trackAction,
  watchGeolocation: (onData, onError) => {
    const { geolocation } = window.navigator;
    const geolocationWatchId = geolocation.watchPosition(onData, onError);
    return () => {
      geolocation.clearWatch(geolocationWatchId);
    };
  },
  back: () => window.history.back(),
  alert: (msg) => window.alert(msg),
};

export default io;
